import { Typography } from '@ascd/witsby-components';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Grid } from '@mui/material';

interface ISelectedFilterData {
  id: string;
  title: string;
}
interface IAdminDashboardSelectedFilterChipsProps {
  data?: ISelectedFilterData[];
  headerTitle?: string;
  summaryText?: string;
  show?: boolean;
  type: 'SCHOOL' | 'GROUP';
}

const AdminDashboardSelectedFilterChips = ({
  data = [],
  headerTitle = 'Selected School(s):',
  summaryText = 'No schools selected',
  show = false,
  type = 'SCHOOL',
}: IAdminDashboardSelectedFilterChipsProps) => (
  <Box>
    <Box
      sx={(theme) => ({
        display: 'flex',
        maxWidth: '100%',
        flexWrap: 'wrap',
        minHeight: '45px',
        alignItems: 'center',
        color: theme.palette.grey[100],
        fontSize: theme.font.size.REGULAR,
      })}>
      <Grid item xl={12} sm={12} xs={12}>
        <Accordion
          sx={{
            '&': {
              px: 2,
              height: '100%',
              boxShadow: '0px 3px 8px 2px rgba(0, 0, 0, 0.14)',
              borderRadius: (theme) => `${theme.border.radius.LARGE} !important`,
              '&:before': {
                display: 'none',
              },
            },
            '& .MuiButtonBase-root': {
              p: 0,
              minHeight: 'auto',
            },
            '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
              m: 0,
            },
            '& .MuiAccordionDetails-root': {
              p: 0,
              mb: '15px',
            },
          }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box
              sx={{
                my: 2,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
              }}>
              <Typography
                tag="h2"
                text={headerTitle}
                sx={(theme) => ({
                  lineHeight: 'auto',
                  color: theme.palette.grey[200],
                  fontSize: theme.font.size.REGULAR,
                  fontWeight: theme.font.weight.BOLD,
                })}
              />
              <Typography
                text={`${data?.length} ${type === 'SCHOOL' ? 'Schools' : 'Groups'}`}
                sx={(theme) => ({
                  lineHeight: 'auto',
                  color: theme.palette.grey[200],
                  fontSize: theme.font.size.REGULAR,
                })}
              />
            </Box>
            {!show && (
              <Box
                sx={{
                  width: '100%',
                  textAlign: 'left',
                  marginBottom: 'auto',
                  marginTop: 'auto',
                  fontSize: (theme) => theme.font.size.REGULAR,
                }}>
                {summaryText}
              </Box>
            )}
          </AccordionSummary>
          {show && (
            <AccordionDetails>
              {(data || [])
                .sort((a, b) => a.title.localeCompare(b.title))
                .map((checkedItem) => (
                  <Chip
                    key={checkedItem.id}
                    label={checkedItem.title}
                    // onDelete={() => onDeleteTag(checkedItem.id)}
                    sx={(theme) => ({
                      my: 0.5,
                      px: 0.5,
                      mr: 0.5,
                      height: '2.3rem',
                      border: '1px solid',
                      backgroundColor: '#efefef',
                      color: theme.palette.grey[100],
                      borderColor: theme.palette.grey[800],
                      borderRadius: theme.border.radius.XX_LARGE,
                      '& .MuiChip-deleteIcon': {
                        pl: 0.1,
                        color: '#00000099',
                      },
                    })}
                  />
                ))}
            </AccordionDetails>
          )}
        </Accordion>
      </Grid>
    </Box>
  </Box>
);

export default AdminDashboardSelectedFilterChips;
